import { Injectable } from '@angular/core';
import { VendorInfo } from '@buyiq-app/product/models/vendor-info';
import { LocalForageService } from '@buyiq-core/storage/local-forage.service';
import { StoreName } from '@buyiq-core/storage/storage';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class VendorInfoStorageService {
    constructor(
        private localForageService: LocalForageService
    ) {
    }

    clearStorage(): Observable<void> {
        return this.localForageService.clearStorage(StoreName.VendorInfo);
    }

    getItem(key: string): Observable<VendorInfo> {
        return this.localForageService.getItem(key, StoreName.VendorInfo);
    }

    setItem(key: string, value: any): Observable<VendorInfo> {
        return this.localForageService.setItem(key, value, StoreName.VendorInfo);
    }
}
